<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import DsLinkBlock from 'JIX/components/ds/DsLinkBlock.vue';
import T from './CompanyProfileAvailableJobsSection.i18n.js';

const store = useStore();

const scriptDoms = ref([]);

const innerScripts = computed(() => store.state.innerScripts);

const graduateProgram = computed(() => {
    const graduate = store.state.leftboxContent.programsInfo.find(program => program.name === 'GRADUATE');
    return graduate;
});

onMounted(() => {
    if ('graduate' in innerScripts.value) {
        for (let script of innerScripts.value.graduate) {
            const scriptElem = document.createElement('script');
            scriptDoms.value.push(scriptElem);
            scriptElem.innerHTML = script;
            document.head.appendChild(scriptElem);
        }
    }
});

onUnmounted(() => {
    for (let dom of scriptDoms.value) {
        dom.remove();
    }
});

function jixAnalytics(label, action) {
    store.dispatch('jixAnalytics', { label, action });
}
</script>

<template>
    <div>
        <div class="mb-3 bg-surface-default border shadow-sm" v-html="store.state.graduateContent" />
        <div
            v-if="graduateProgram"
            class="mb-3 bg-surface-default border d-md-none"
        >
            <div class="text-brand text-center display-4 mt-2">
                {{ graduateProgram.count }}
            </div>
            <div class="mb-2 text-center align-middle">
                {{ T.typeText(graduateProgram.name) }}
            </div>
            <hr class="m-0">
            <DsLinkBlock
                :href="graduateProgram.url"
                @click="jixAnalytics('se-graduate-programmer', 'klik-venstre-navigation')"
                :link-class="'justify-content-center py-2 w-100 text-sm'"
            >
                {{ T.linkText(graduateProgram.name) }}
            </DsLinkBlock>
        </div>
    </div>
</template>
